import { Stack, Typography, Card, useTheme } from "@mui/material";

import { RHFTextField } from "@app/components";
import { Strings } from "@app/constants";

type Props = { isMobile: boolean };

export const BookingInfoForm = ({ isMobile }: Props) => {
  const theme = useTheme();

  return (
    <Card variant="outlined" sx={{ mb: 3, p: 3, width: "100%" }}>
      <Stack direction="row" justifyContent="space-between" mb={1}>
        <Stack>
          <Typography
            fontFamily="Work Sans"
            fontWeight={700}
            color={theme.palette.grey[900]}
          >
            {Strings.buy.bookingInfo}
          </Typography>
          <Typography
            fontFamily="Work Sans"
            fontWeight={500}
            sx={{ color: theme.palette.grey[600], fontSize: 15 }}
          >
            {Strings.buy.pleaseEnterYour}
          </Typography>
        </Stack>
        {/* <Typography
          variant="caption"
          sx={{ color: theme.palette.primary.dark }}
        >
          {Strings.buy.step1of4}
        </Typography> */}
      </Stack>

      <Stack spacing={2}>
        <Stack direction={isMobile ? "column" : "row"} gap={2}>
          <Stack flex={1}>
            <Typography
              fontWeight={600}
              mb={0.5}
              sx={{ color: theme.palette.grey[900] }}
            >
              {Strings.auth.name}
            </Typography>
            <RHFTextField name="name" placeholder="Your name" fullWidth />
          </Stack>
          <Stack flex={1}>
            <Typography
              fontWeight={600}
              mb={0.5}
              sx={{ color: theme.palette.grey[900] }}
            >
              {Strings.buy.phoneNumber}
            </Typography>
            <RHFTextField
              name="phoneNumber"
              placeholder="Phone number"
              fullWidth
            />
          </Stack>
        </Stack>

        <Stack direction={isMobile ? "column" : "row"} gap={2}>
          <Stack flex={1}>
            <Typography
              fontWeight={600}
              mb={0.5}
              sx={{ color: theme.palette.grey[900] }}
            >
              {Strings.buy.address}
            </Typography>
            <RHFTextField name="address" placeholder="Address" fullWidth />
          </Stack>
          <Stack flex={1}>
            <Typography
              fontWeight={600}
              mb={0.5}
              sx={{ color: theme.palette.grey[900] }}
            >
              {Strings.buy.townCity}
            </Typography>
            <RHFTextField
              name="townOrCity"
              placeholder="Town or city"
              fullWidth
            />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
